<template>
  <transition
    name="outer-text-transition"
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
  >
  <div class="breathingCircleArea"
    v-if="show"
  >

    <div

      v-bind:class="{
        breathingCircleWrapper: true
      }"

      v-bind:style="{
        height: `${size}px`,
        width: `${size}px`,
        background: backgroundColor,
      }"
    >
      <div

        v-bind:class="{
          breathingCircle: true
        }"

        v-bind:style="{
          height: `${circleSize}px`,
          width: `${circleSize}px`,
          background: circleColor,
          transitionDuration: `${currentDuration}ms`,
        }"
      >
        <div

          v-bind:class="{
          breathingCircle: true
        }"

          v-bind:style="{
            height: `${circleSize === circleMaxSize ? circleSize*0.75 : circleSize}px`,
            width: `${circleSize === circleMaxSize ? circleSize*0.75 : circleSize}px`,
            background: circleColor,
            transitionDuration: `${currentDuration}ms`,
        }"
        >
          <div

            v-bind:class="{
          breathingCircle: true
        }"

            v-bind:style="{
              height: `${circleSize === circleMaxSize ? circleSize*0.75*0.75 : circleSize}px`,
              width: `${circleSize === circleMaxSize ? circleSize*0.75*0.75 : circleSize}px`,
              background: circleColor,
              transitionDuration: `${currentDuration}ms`,
              color: innerTextColor
        }"
          >
            {{innerCaption}}
          </div>

        </div>

      </div>
    </div>

    <div class="outerCaptionWrapper">
      <transition
        name="outer-text-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="breathingCircleOuterCaption" v-if="outerCaption" v-bind:style="{color: outerTextColor}">{{outerCaption}}</div>
      </transition>
    </div>
  </div>
  </transition>

</template>

<script>

  import {sleep} from "@/util/sleep";

  export default {
    name: 'BreathingCircle',
    components: {},
    props: {
      size: Number,
      backgroundColor: String,
      scenario: Array,
      outerTextColor: String,
      innerTextColor: String,
    },
    data() {
      return {
        padding: 16,
        circleMinSize: 75,
        currentSize: 0,
        currentDuration: 5,
        defaultCircleColor: 'rgba(33, 146, 240, 0.3333)',
        customCircleColor: '',
        outerCaption: '',
        innerCaption: '3',
        show: false,
      }
    },

    computed: {
      circleMaxSize: function () {
        return this.size - this.padding;
      },

      circleSize: function () {
        return Math.max(this.circleMinSize, Math.min(this.circleMaxSize, this.currentSize))
      },

      circleColor: function () {
        return this.customCircleColor ? this.customCircleColor : this.defaultCircleColor
      }


    },

    methods: {

      playInhaleAnimation: async function (duration) {
          this.currentDuration = duration;
          this.currentSize = this.circleMaxSize;

          return await sleep(duration);
      },

      playExhaleAnimation: async function (duration) {
          this.currentDuration = duration;
          this.currentSize = this.circleMinSize;

          return await sleep(duration);
      },

      playHoldAnimation: async function (duration) {
          this.currentDuration = duration;

          return await sleep(duration);
      },

      playCountDownAnimation: async function (duration, timer) {
        let stepDuration = duration/timer;
        this.innerCaption = timer;

        for (let i = timer; i > 0; i--) {
            this.innerCaption = timer--;
            await sleep(stepDuration);
        }

        return true;

      },

      async setInnerCaption(newValue) {
        this.innerCaption = '';
        await sleep(10);
        this.innerCaption = newValue;
      },

      async setOuterCaption(newValue) {
        this.outerCaption = '';
        await sleep(10);
        this.outerCaption = newValue;
      }



    },

    async created() {
      this.currentSize = this.circleMinSize;
      await sleep(50);
      this.show = true;

      for (let i = 0; i < this.scenario.length; i++) {
        let step = this.scenario[i];
        this.$emit('stepStarted', step);

        await this.setOuterCaption(step.outerCaption || '');
        await this.setInnerCaption(step.innerCaption || '');
        if (step.color) this.customCircleColor = step.color;

        console.log(`Start step ${step.outerCaption}`);
        switch (step.type) {
          case 'countdown':
            await this.playCountDownAnimation(step.duration, step.timer);
            break;
          case 'inhale':
            await this.playInhaleAnimation(step.duration);
            break;
          case 'exhale':
            await this.playExhaleAnimation(step.duration);
            break;
          case 'hold':
            await this.playHoldAnimation(step.duration);
            break;
        }

        this.$emit('stepFinished', step);

      }
      this.$emit('scenarioFinished', this.scenario);
      this.$emit('finish', this.scenario);

    }
  }
</script>

<style lang="scss">
  @import "src/assets/scss/variables";

  .breathingCircleArea {
    justify-content: center;
    flex-direction: column;
    align-content: center;
    display: flex;
    text-align: center;
  }

  .breathingCircle {
    border-radius: 100%;
    transition-timing-function: linear;
    transition-property: all;

    justify-content: center;
    flex-direction: column;
    align-content: center;
    display: flex;

    font-size: $title2FontSize;

  }

  .breathingCircleWrapper {
    border-radius: 100%;
    display: flex;
    align-content: center;
    height: 100%;
    flex-direction: column;
    width: 100%;
    justify-content: center;
  }

  .breathingCircleOuterCaption {
    font-style: normal;
    font-weight: normal;
    font-size: $title2FontSize;
    line-height: $title2LineHeight;
    letter-spacing: $title2LetterSpacing;
    margin: $primaryMargin;
    padding: $bigPadding;
    color: #2E2F34;

  }

  .outerCaptionWrapper {
    min-height: 110px;
  }

</style>
